import { useMemo } from "react";
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts";

export default function AdminSignupsChart({ stats }) {
  const data = useMemo(
    () => (stats?.signups_30d || []).map((p) => ({ ...p, label: p.date.slice(5) })),
    [stats],
  );

  return (
    <div className="bg-white border border-stone-200 rounded-2xl p-6" data-testid="signups-chart-card">
      <h2 className="font-display text-xl font-medium mb-1">Signups · last 30 days</h2>
      <p className="text-xs text-stone-500 mb-4">New accounts per day.</p>
      <div className="h-56 min-w-[300px]">
        {stats && (
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={data} margin={{ top: 8, right: 8, left: -16, bottom: 0 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="#E7E5E4" vertical={false} />
              <XAxis dataKey="label" tickLine={false} axisLine={false} tick={{ fill: "#57534E", fontSize: 11 }} interval={4} />
              <YAxis allowDecimals={false} tickLine={false} axisLine={false} tick={{ fill: "#57534E", fontSize: 11 }} width={28} />
              <Tooltip contentStyle={{ borderRadius: 12, border: "1px solid #E7E5E4", fontSize: 12 }} formatter={(v) => [v, "signups"]} />
              <Line type="monotone" dataKey="count" stroke="#EAB308" strokeWidth={2.5} dot={{ r: 3, fill: "#EAB308" }} />
            </LineChart>
          </ResponsiveContainer>
        )}
      </div>
    </div>
  );
}
